<template>
    <div :class="['search-input-dropdown', { 'show-dropdown': dropdownShow }]" v-outsideclick="outsideclick">
        <!-- @focus="handleFocus" -->
        <div class="input" @click="toggleDropdown(!dropdownShow)">
            <number-input
                v-bind="$attrs"
                :theme="theme"
                :placeholder="placeholder"
                :dataType="dataType"
                :value="inputVal"
                @update:value="onUpdate"
                @numberBlur="onBlur"
                :ref="onRef"
            />
        </div>

        <transition name="zoom-in-top">
            <div
                v-show="dropdownShow"
                v-if="options.length > 0"
                class="dropdown"
                :class="dropdownClass"
            >
                <ul class="dd-container" :class="dropContainerClass">
                    <li
                        class="dd-item"
                        :class="[theme, { selected: inputVal === '' }]"
                        @click="handleClk('')"
                        v-if="options.length > 0 && $slots.prependAny"
                    >
                        <slot name="prependAny"></slot>
                    </li>
                    <li
                        class="dd-item"
                        v-for="item in options"
                        :key="item.key"
                        :class="[theme, { selected: inputVal == item.key }]"
                        @click="handleClk(item.key)"
                    >
                        {{ item.label }}
                    </li>
                    <li
                        class="dd-item"
                        v-if="options.length > 0 && $slots.appendAny"
                        :class="[theme, { selected: inputVal === '' }]"
                        @click="handleClk('')"
                    >
                        <slot name="appendAny"></slot>
                    </li>
                </ul>
            </div>
        </transition>
    </div>
</template>

<script>
import { mapState } from 'pinia';
import { usePageStore } from '@/store';
import classNames from 'classnames';
import NumberInput from '../number-input';
import util from '@/common/util';

export default {
    name: 'InputDropdown',
    componentName: 'input-dropdown',
    components: { 'number-input': NumberInput },
    emits: ['update:value', 'input', 'blur'],
    inject: {
        registerDropDown: {
            default: null
        }
    },
    props: {
        options: {
            type: Array,
            default: () => []
        },
        theme: {
            type: String,
            default: 'standard'
        },
        placeholder: {
            type: String,
            default: ''
        },
        value: {
            type: [String, Number],
            default: ''
        },
        inMore: {
            type: Boolean,
            default: true
        },
        dataType: {
            type: String,
            default: ''
        }
    },
    data: function() {
        return {
            dropdownShow: false,
        
            inputNumberRef: null,

            inputVal: this.getInputByValue()

        };
    },
    watch: {
        value: function() {
            this.inputVal = this.getInputByValue();
        }
    },
    computed: {
        ...mapState(usePageStore, {
            currencyRate: store => store.currencyRate,
            currencySymbol: store => store.currency.symbol,
            currencyAbbr: store => store.currency.abbr,
            baseCurrency: store => store.baseCurrency
        }),
        isCurCurrencyEqualBaseCurrency() {
            //  Determine whether the currently selected currency is equal to the base currency ；
            return this.currencyAbbr === this.baseCurrency;
        },
        itemClass() {
            return classNames(this.theme);
        },
   
        dropdownClass() {
            return classNames({ outside: !this.inMore });
        },
        dropContainerClass() {
            return classNames(this.theme, { outerside: !this.inMore });
        }
    },
    mounted() {
        this.inputVal = this.getInputByValue();
        this.registerDropDown && this.registerDropDown(this, true);
    },
    beforeUnmount() {
        this.registerDropDown && this.registerDropDown(this, false);
    },
    methods: {
        onRef(e) {
            this.inputNumberRef = e;
        },
        // outside click
        outsideclick() {
            this.toggleDropdown(false);
        },
        // blur event
        onBlur() {
            this.$emit('blur');
        },
        onUpdate(v) {
            this.inputVal = v;
            this.emitUpdate(v);
        },
        emitUpdate(val) {
            if (
                this.dataType === 'money' &&
                    !this.isCurCurrencyEqualBaseCurrency
            ) {
                this.$emit(
                    'update:value',
                    util.transferPriceToDollar({
                        price: val,
                        isInt: true,
                        currencyRate: this.currencyRate
                    })
                );
                return;
            }
            this.$emit('update:value', val);
        },
        getInputByValue() {
            if (
                this.dataType === 'money' &&
                    !this.isCurCurrencyEqualBaseCurrency
            ) {
                if (
                    util.transferPriceToDollar({
                        price: this.inputVal,
                        isInt: true,
                        currencyRate: this.currencyRate
                    }) == this.value
                ) {
                    return this.inputVal;
                } else {
                    return util.transferDollarToCurrency({
                        price: this.value,
                        isInt: true,
                        currencyRate: this.currencyRate
                    });
                }
            }
            return this.value;
        },
        // toggle dropdown
        toggleDropdown(status) {
            this.dropdownShow = status;
        },
        // when outside, on show
        // call by outside-range
        outsideOnShow() {
            this.dropdownShow = true;
            this.inputNumberRef?.inputRef &&
                this.inputNumberRef.inputRef.focus();
        },
        // click event
        handleClk(v) {
            this.inputVal = v;
            this.emitUpdate(v);
            this.$emit('blur');
            this.toggleDropdown(false);
        }
    }
};
</script>

<style lang="scss">
@import '@/theme/mixin.scss';
.search-input-dropdown {
    position: relative;
    height: 100%;
    width: 100%;
    .input {
        height: 40px;
        width: 100%;
    }
    .dropdown {
        padding-top: 2px;
        position: absolute;
        left: 0;
        right: 0;
        top: 100%;
        z-index: var(--level-high);
        background: #fff;
        &.outside {
            position: relative;
            top: 0;
        }
        .dd-container {
            border-radius: 2px;
            padding: 10px 0;
            &.standard {
                border: solid 1px #ebecf1;
                &.outerside {
                    border: none;
                }
            }
            &.template4 {
                border: solid 1px #d6dae8;
                &.outerside {
                    border: none;
                }
            }
            &.template1 {
                border: solid 1px #d5d5d5;
                &.outerside {
                    border: none;
                }
            }
            .dd-item {
                padding: 0 10px 0 15px;
                height: 32px;
                line-height: 32px;
                display: flex;
                cursor: pointer;
                color: var(--g-text-color);
                &.selected {
                    color: var(--g-btn-background);
                }
                @include color-button-hover();
            }
        }
    }
}

// dropdown  animation
$--im-fade-transition: transform 300ms cubic-bezier(0.23, 1, 0.32, 1),
    opacity 300ms cubic-bezier(0.23, 1, 0.32, 1) !default;
.zoom-in-top-enter {
    opacity: 0;
    transform: scaleY(0);
}
.zoom-in-top-enter-active,
.zoom-in-top-leave-active {
    transform: scaleY(1);
    opacity: 1;
    transform-origin: center top;
    transition: $--im-fade-transition;
}
.zoom-in-top-leave-active {
    transform: scaleY(0);
    opacity: 0;
}
</style>
